import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../../api/admin.api';

export const StatisticsOverview: React.FC = () => {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['adminStats'],
    queryFn: async () => {
      const response = await adminApi.getAdminStats();
      return response.data;
    },
  });

  if (isLoading) {
    return <div className="p-6 text-center">로딩 중...</div>;
  }

  const statCards = [
    {
      title: '사용자',
      mainValue: stats?.totalUsers || 0,
      mainLabel: '전체',
      subValue: stats?.activeUsers || 0,
      subLabel: '활성',
      color: 'bg-blue-50 text-blue-700',
      icon: '👥',
    },
    {
      title: '질문',
      mainValue: stats?.totalQuestions || 0,
      mainLabel: '전체',
      subValue: stats?.questionsToday || 0,
      subLabel: '오늘',
      color: 'bg-purple-50 text-purple-700',
      icon: '❓',
    },
    {
      title: '신고',
      mainValue: stats?.totalReports || 0,
      mainLabel: '전체',
      subValue: stats?.pendingReports || 0,
      subLabel: '대기중',
      color: 'bg-red-50 text-red-700',
      icon: '⚠️',
    },
    {
      title: '문의',
      mainValue: stats?.totalInquiries || 0,
      mainLabel: '전체',
      subValue: stats?.pendingInquiries || 0,
      subLabel: '대기중',
      color: 'bg-indigo-50 text-indigo-700',
      icon: '💬',
    },
  ];

  return (
    <div className="space-y-4">
      {/* Desktop Grid */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((card, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm p-6 border border-[#E5E7EB]"
          >
            <div className="flex items-start justify-between mb-4">
              <h3 className="text-sm font-medium text-[#6B7280]">{card.title}</h3>
              <div className={`text-2xl ${card.color} p-3 rounded-lg`}>
                {card.icon}
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex items-baseline justify-between">
                <span className="text-xs text-[#6B7280]">{card.mainLabel}</span>
                <span className="text-2xl font-bold text-[#030213]">
                  {card.mainValue.toLocaleString()}
                </span>
              </div>
              <div className="flex items-baseline justify-between pt-2 border-t border-[#E5E7EB]">
                <span className="text-xs text-[#6B7280]">{card.subLabel}</span>
                <span className="text-lg font-semibold text-[#6B7280]">
                  {card.subValue.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-3">
        {statCards.map((card, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm p-4 border border-[#E5E7EB]"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className={`text-xl ${card.color} p-2 rounded-lg`}>
                  {card.icon}
                </div>
                <h3 className="text-sm font-medium text-[#030213]">{card.title}</h3>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="text-center p-2 bg-[#f3f3f5] rounded-lg">
                <p className="text-xs text-[#6B7280] mb-1">{card.mainLabel}</p>
                <p className="text-xl font-bold text-[#030213]">
                  {card.mainValue.toLocaleString()}
                </p>
              </div>
              <div className="text-center p-2 bg-[#f3f3f5] rounded-lg">
                <p className="text-xs text-[#6B7280] mb-1">{card.subLabel}</p>
                <p className="text-xl font-bold text-[#030213]">
                  {card.subValue.toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
